import React from "react";

import { makeStyles } from "tss-react/mui";

import { MealKind } from "@/gql/graphql";
import AfternoonSnacksIcon from "@components/Icons/AfternoonSnacksIcon";
import BreakfastIcon from "@components/Icons/BreakfastIcon";
import BrunchIcon from "@components/Icons/BrunchIcon";
import DefaultMealIcon from "@components/Icons/DefaultMealIcon";
import DinnerIcon from "@components/Icons/DinnerIcon";
import LunchIcon from "@components/Icons/LunchIcon";
import PostWorkoutIcon from "@components/Icons/PostWorkoutIcon";
import PreWorkoutIcon from "@components/Icons/PreWorkoutIcon";
import SecondAfternoonSnackIcon from "@components/Icons/SecondAfternoonSnack";
import SecondBreakfastIcon from "@components/Icons/SecondBreakfastIcon";
import SecondMorningSnackIcon from "@components/Icons/SecondMorningSnackIcon";
import SnackIcon from "@components/Icons/SnackIcon";
import SupperIcon from "@components/Icons/SupperIcon";

const useStyles = makeStyles()({
  breakfast: {
    width: 40,
    height: 34,
  },
  brunch: {
    width: 45,
    height: 40,
  },
  snack: {
    width: 35,
    height: 40,
  },
  preWorkout: {
    width: 40,
    height: 36,
  },
  default: {
    width: 40,
    height: 40,
  },
  small: {
    width: 20,
    height: 20,
  },
  grayscale: {
    filter: "grayscale(100%)",
  },
});

interface Props {
  type: MealKind | "NO_MEAL";
  size?: "small" | "large";
  grayscale?: boolean;
}

const MealTypeIcon: React.FC<Props> = ({
  type,
  size = "large",
  grayscale = false,
}) => {
  const { classes, cx } = useStyles();
  const large = size === "large";
  const small = size === "small";
  switch (type) {
    case MealKind.Breakfast:
      return (
        <BreakfastIcon
          className={cx({
            [classes.breakfast]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.Brunch:
      return (
        <BrunchIcon
          className={cx({
            [classes.brunch]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.Lunch:
      return (
        <LunchIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.AfternoonSnack:
      return (
        <AfternoonSnacksIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.Dinner:
      return (
        <DinnerIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.Supper:
      return (
        <SupperIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.Snack:
      return (
        <SnackIcon
          className={cx({
            [classes.snack]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.PreWorkoutSnack:
      return (
        <PreWorkoutIcon
          className={cx({
            [classes.preWorkout]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.PostWorkoutSnack:
      return (
        <PostWorkoutIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.MorningSnack:
      return (
        <SecondBreakfastIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.PreWorkoutMeal:
      return (
        <SecondMorningSnackIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case MealKind.PostWorkoutMeal:
      return (
        <SecondAfternoonSnackIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    case "NO_MEAL":
      return (
        <DefaultMealIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
    default:
      return (
        <DefaultMealIcon
          className={cx({
            [classes.default]: large,
            [classes.small]: small,
            [classes.grayscale]: grayscale,
          })}
        />
      );
  }
};

export default MealTypeIcon;
